import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const isDev = import.meta.env.MODE === 'development';

const httpClient = axios.create({
  // In development, Vite's proxy rewrites '/tour' to the full API URL to avoid CORS issues.
  // In UAT and production environments, the proxy is not used and calls must go directly to the full API endpoint.
  baseURL: isDev ? '/tour' : `${import.meta.env.TOURPWA_TOUR_APP_URL}/api`,
  // timeout: 10000, // 10k ms = 10 s
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setupInterceptors = (authToken: string) => {
  httpClient.interceptors.request.use(
    async (config) => {
      config.headers['Authorization'] = `Bearer ${authToken}`;

      const controller = new AbortController();
      config.signal = controller.signal;

      const handleOffline = () => controller.abort();
      window.addEventListener('offline', handleOffline);

      // add custom metadata safely via casting
      (config as any).metadata = {
        cleanup: () => window.removeEventListener('offline', handleOffline),
      };

      return config;
    },
    (error) => Promise.reject(error),
  );
};

// GET
export const getRequest = async (url: string, params = {}, config: AxiosRequestConfig = {}) => {
  return httpClient.get(url, {
    params,
    ...config,
  });
};

// POST
export const postRequest = async <T>(url: string, data = {}, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> => {
  try {
    const response = await httpClient.post(url, data, { ...config });
    return response;
  } catch (error) {
    // TODO: Save error to ErrorLogRepo
    console.error(error);
    throw error;
  }
};

// DELETE
export const deleteRequest = async (url: string, params = {}, config: AxiosRequestConfig = {}) => {
  try {
    const response = await httpClient.delete(url, {
      params,
      ...config,
    });
    return response;
  } catch (error) {
    // TODO: Save error to ErrorLogRepo
    console.error(error);
    throw error;
  }
};
